import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-process-download',
  templateUrl: './upload.component.html',
  styleUrls: ['../process.component.css'],
})
export class UploadComponent extends BaseComponent {
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/process/upload/upload.component.ts